var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isShowProductChoice,
        center: "",
        title: "选择产品",
        top: "18vh",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShowProductChoice = $event
        },
        close: _vm.onClose,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            padding: "20px 20px 40px",
          },
        },
        _vm._l(_vm.productList, function (item, index) {
          return _c(
            "el-card",
            {
              key: index,
              staticStyle: { margin: "10px", width: "450px" },
              attrs: { "body-style": { padding: "20px" } },
            },
            [
              _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                _c("div", {
                  staticStyle: {
                    "font-size": "1.2em",
                    "font-weight": "bold",
                    height: "70px",
                  },
                  domProps: { innerHTML: _vm._s(item.pubName) },
                }),
              ]),
              _c(
                "el-row",
                { attrs: { justify: "center", type: "flex", align: "center" } },
                [
                  _c("div", [
                    _c("span", {
                      staticStyle: {
                        "font-size": "1.1em",
                        "font-weight": "bold",
                      },
                      domProps: { innerHTML: _vm._s(item.description) },
                    }),
                    item.pubPrice
                      ? _c("div", [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "1.3em",
                                "font-weight": "bold",
                                color: "#ff4500",
                              },
                            },
                            [_vm._v("￥" + _vm._s(item.pubPrice) + " 起")]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "30px" },
                  attrs: { justify: "center", type: "flex" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.handleDetail(item)
                        },
                      },
                    },
                    [_vm._v("查看详情")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleInsure(item)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }